import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import type { CustomAlarmTypeConnection } from '@/graphql/types';
import ChoiceField from './ChoiceField';
import type { FieldOptions } from '../types';

const GET_CUSTOM_ALARM_IDS_AND_NAMES = gql`
    query GetCustomAlarmIdsAndNames {
        customAlarms {
            edges {
                node {
                    pk
                    name
                }
            }
        }
    }
`;

interface SelfDefinedAlarmLineFieldProps {
    fieldOptions: FieldOptions;
}

export function SelfDefinedAlarmLineField({ fieldOptions }: SelfDefinedAlarmLineFieldProps) {
    const { data } = useQuery<{ customAlarms: CustomAlarmTypeConnection }>(
        GET_CUSTOM_ALARM_IDS_AND_NAMES,
        {
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'cache-first',
        }
    );

    const extraChoiceOptions = useMemo(() => {
        const nodes = data?.customAlarms?.edges?.map((edge) => edge?.node) ?? [];
        return nodes.map((node) => [node!.pk, node!.name] as [string, string]);
    }, [data]);

    return (
        <ChoiceField
            fieldOptions={fieldOptions}
            extraChoiceOptions={extraChoiceOptions}
            addOptionWhenMissing={true}
        />
    );
}
